import { clientWithApiClient } from "../../../client";
import type { ApiClient } from "../../../types";

import type { ListResponse, Response } from "../../../types";
import type { VehiclePhoto, ReorderVehiclePhotosRequest } from "./types";

const list = (apiClient: ApiClient, vehicleId: string) =>
  clientWithApiClient<ListResponse<VehiclePhoto>>(
    apiClient,
    `/vehicles/${vehicleId}/photos`,
  );

const get = (apiClient: ApiClient, vehicleId: string, id: string) =>
  clientWithApiClient<Response<VehiclePhoto>>(
    apiClient,
    `/vehicles/${vehicleId}/photos/${id}`,
  );

const create = (
  apiClient: ApiClient,
  vehicleId: string,
  formData: FormData,
) => {
  return clientWithApiClient<Response<VehiclePhoto>>(
    apiClient,
    `/vehicles/${vehicleId}/photos`,
    {
      method: "POST",
      body: formData,
    },
  );
};

const update = (
  apiClient: ApiClient,
  vehicleId: string,
  id: string,
  formData: FormData,
) => {
  return clientWithApiClient<Response<VehiclePhoto>>(
    apiClient,
    `/vehicles/${vehicleId}/photos/${id}`,
    {
      method: "PUT",
      body: formData,
    },
  );
};

const remove = (apiClient: ApiClient, vehicleId: string, id: string) =>
  clientWithApiClient(
    apiClient,
    `/vehicles/${vehicleId}/photos/${id}?delete_resource=true&delete_type=hard`,
    {
      method: "DELETE",
    },
  );

const reorder = (
  apiClient: ApiClient,
  vehicleId: string,
  request: ReorderVehiclePhotosRequest,
) =>
  clientWithApiClient(apiClient, `/vehicles/${vehicleId}/photos/reorder`, {
    method: "PUT",
    body: JSON.stringify(request),
  });

export const photos = {
  list,
  get,
  create,
  update,
  delete: remove,
  reorder,
};
